import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import {
  Section,
  Container,
  Grid,
  Col,
  Button,
  SanityBlockContent,
} from '../../common';
import { getMaxWidthClass } from '../../../utils';

const StyledHeadline = styled.h2`
  color: ${(props) => props.$color} !important;
  &:hover {
    color: ${(props) => props.$colorHover} !important;
  }
`;

const StyledLink = styled((props) => <Link {...props} />)`
  color: ${(props) => props.$color} !important;
  &:hover {
    color: ${(props) => props.$colorHover} !important;
  }
`;

const CtaHalf = ({ sanity, page, section }) => {
  const { colors } = sanity;
  const maxWidthClassHeadline = getMaxWidthClass(section?.header?.headline);
  const maxWidthClassDescription = getMaxWidthClass(
    section?.header?._rawDescription
  );

  return (
    <Section
      idName="cta-half"
      padding="none"
      bgColor={colors?.neutral?.dark}
      h2Color={colors?.accent?.light}
    >
      <Container padding="none">
        <Grid classes="lg:grid-cols-2 gap-0">
          {/* Left Column: Image */}
          <Col classes="">
            <GatsbyImage
              image={section?.image?.asset?.gatsbyImageData}
              alt={section?.image?.alt}
              className="object-cover object-center w-full h-full aspect-h-7 aspect-w-12"
              loading="lazy"
            />
          </Col>
          {/* Right Column: Text Content with cascading animation */}
          <Col classes="max-h-min px-8 py-8 lg:py-8">
            <Container padding="none">
              {/* Tagline with no delay */}
              <Container
                disableAnimations={false}
                padding="none"
                animationDelay={0}
                classes=""
              >
                <span className="text-base font-semibold uppercase tracking-wider !text-zinc-300">
                  {section?.header?.tagline}
                </span>
              </Container>
              {/* Headline with a slight delay */}
              <Container
                disableAnimations={false}
                padding="none"
                animationDelay={0.2}
                classes=""
              >
                <StyledHeadline
                  className={`${maxWidthClassHeadline} mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl`}
                  $color={colors?.accent?.light}
                >
                  {section?.header?.headline}
                </StyledHeadline>
              </Container>
              {/* Description with a further delay */}
              <Container
                disableAnimations={false}
                padding="none"
                animationDelay={0.4}
                classes=""
              >
                <div
                  className={`${maxWidthClassDescription} mt-6 text-lg !text-zinc-300`}
                >
                  <SanityBlockContent
                    sanity={sanity}
                    blocks={section?.header?._rawDescription}
                  />
                </div>
              </Container>
              {/* Button with the longest delay */}
              <Container
                disableAnimations={false}
                padding="none"
                animationDelay={0.6}
                classes="flex justify-center lg:justify-start mt-12"
              >
                {section?.ctaButtonLabel && (
                  <div className="gap-4 mx-auto lg:mx-0">
                    <Button
                      linkType="internal"
                      internalLink={section?.ctaButtonLink?.slug?.current}
                      label={section?.ctaButtonLabel}
                      sanity={sanity}
                      page={page}
                    />
                  </div>
                )}
              </Container>
            </Container>
          </Col>
        </Grid>
      </Container>
    </Section>
  );
};

CtaHalf.displayName = 'CtaHalf';

export { CtaHalf };
